// export function checkFieldWithoutHtmlTag (value) {
//     let regexForHTML = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
  
//     return !regexForHTML.test(value);
// }

export function checkFieldWithoutHtmlTag(value) {
    const htmlRegex = /<[^>]*>|&[#\w]+;/g;
    const scriptRegex = /javascript:|data:/i;

    if (typeof value === 'string') {
        return !(htmlRegex.test(value) || scriptRegex.test(value));
    }
    // If not a string, consider it safe (or handle as needed)
    return true;
}